var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathwaysDashboardSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 358"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 2,
    cy: 1,
    r: 1,
    fill: "#FF7228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M5 1H13C14.1046 1 15 1.89543 15 3V4.5C15 5.60457 14.1046 6.5 13 6.5H3C1.89543 6.5 1 7.39543 1 8.5V10.5C1 11.6046 1.89543 12.5 3 12.5H14.5M14.5 12.5L12 15M14.5 12.5L12 10",
    stroke: "#FF7228",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 8,
    cy: 6.5,
    r: 3,
    fill: "#FF7228"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathwaysDashboardSelected);
export default __webpack_public_path__ + "static/media/pathways-dashboard-selected.9c9dafe48f000f4062652d8dfe476ae0.svg";
export { ForwardRef as ReactComponent };